export default __webpack_public_path__ + "static/media/mobile-alt.d89c9179.svg";